<!-- Error page owns its page stack so it does not depend on lab-layout utility classes. -->
<div class="lab-error-page-shell">
  <div class="lab-navbar-header-logo"></div>
  <lab-empty-state [heading]="heading$()" [action]="action$()" [customContent]="true" (action)="onAction()">
    <div class="lab-error-page-message-stack">
      @for (message of messages$(); track message.text) {
        <div>{{ message | translate }}</div>
      }
      @if (showUsername$()) {
        <div class="lab-error-page-username-row">
          <div>{{ username$() }}</div>
          <lab-button
            [variant]="copyButton.type"
            [icon]="copyButton.icon"
            [ariaLabel]="copyButton.ariaLabel"
            (click)="onCopy()"
          />
        </div>
      }
    </div>
  </lab-empty-state>
</div>
